import { IApplicationState, TCardId } from '../../../../../../types/types';

export const  getFilterIgnoreCardIds = (
    state: IApplicationState,
): TCardId[] => {
    return state.filters.filterMatch.ignoreCardIds || [];
};
